/*
 * src/components/SessionProvider/SessionProvider.tsx
 * 
 * Session provider that wraps the entire app and manages session timeouts
 */

import React from 'react';
import { useSessionManager } from '../../hooks/useSessionManager';
import SessionWarningDialog from '../SessionWarningDialog/SessionWarningDialog';
import { logout } from '../../utils/auth';

interface SessionProviderProps {
  children: React.ReactNode;
}

const SessionProvider: React.FC<SessionProviderProps> = ({ children }) => {
  const {
    isWarningVisible,
    warningData,
    extendSession,
    getRemainingTime,
    isTokenValid,
  } = useSessionManager();

  const handleLogoutNow = async () => {
    try {
      await logout('user clicked logout now in warning dialog');
    } catch (error) {
      console.error('Error during logout from session provider', {
        error: error instanceof Error ? error.message : String(error)
      });
    }
    // Hard redirect as ultimate safety net — if the async logout chain got stuck
    // or the Gatsby navigate failed, this guarantees the user reaches the login page.
    if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/log-ind')) {
      window.location.href = '/log-ind/';
    }
  };

  return (
    <>
      {children}
      
      <SessionWarningDialog
        open={isWarningVisible}
        timeRemaining={warningData.timeRemaining}
        type={warningData.type}
        onExtendSession={extendSession}
        onLogoutNow={handleLogoutNow}
      />
    </>
  );
};

export default SessionProvider; 